import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Roles from "pages/Roles/Roles"
import Users from "pages/Users/Users"
// import Customers from "pages/Customers/Customers"
import Timeline from "pages/Timeline"
import JobApplication from "pages/JobApplication"
import JobApplicationDetails from "pages/JobApplication/JobApplicationDetails"
import InterviewSchedule from "pages/InterviewSchedule"
import CreateInterviewSchedule from "pages/InterviewSchedule/CreateInterviewSchedule"
import MyInterviews from "pages/MyInterviews"
import Interviews from "pages/Interviews"
import InterViewStart from "pages/InterViewStart"

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // Profile
  { path: "/profile", component: <UserProfile /> },
  // CANDIDATE
  { path: "/time-line", component: <Timeline /> },
  { path: "/my-interviews", component: <MyInterviews /> },

  // Roles
  // { path: "/roles", component: <Roles /> },

  // { path: "/customers", component: <Customers /> },

  { path: "/applications", component: <JobApplication /> },
  { path: "/application-details", component: <JobApplicationDetails /> },

  //
  { path: "/interview-appointments", component: <InterviewSchedule /> },
  {
    path: "/interview-appointments/create",
    component: <CreateInterviewSchedule />,
  },
  { path: "/interviews", component: <Interviews /> },
  { path: "/test", component: <InterViewStart /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/profile" />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  // { path: "/register", component: <Register /> },
]

export { authProtectedRoutes, publicRoutes }
